<template>
    <div>
        <b-table
        :data="membersCount > 0 ? members : []"
        :loading="membersLoading">
            
            <template slot-scope="props">
                
                <b-table-column field="fullName" label="Nombre" >
                    {{props.row.fullName}}
                </b-table-column>

                <b-table-column field="userEmail" label="Email" >
                    {{props.row.userEmail}}
                </b-table-column>

                <b-table-column field="userPhoneNumber" label="Numero de telefono" >
                    {{props.row.userPhoneNumber}}
                </b-table-column>

            </template>
            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="frown"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Nada por aqui.</p>
                    </div>
                </section>
            </template>
        </b-table>
        <div class="p-top-30 p-b-30">
            <b-pagination
                :total="membersCount"
                :per-page="perPage"
                :current.sync="membersPage"
                :range-before="2"
                :rounded="true"
                :range-after="2"
                order="is-centered"
                @change="memberPageChange"
                icon-prev="chevron-left"
                icon-next="chevron-right"
            >
            </b-pagination>
        </div>

        <div class="columns is-centered">
            <div class="column is-full has-text-centered">
                <b-button
                type="is-primary"
                rounded
                @click="invitesModal = true">
                    <b-icon icon="plus" size="is-small"></b-icon>
                    Invitar miembros
                </b-button>
            </div>
        </div>

        <h2 v-if="invitations" class="is-title is-size-4 m-t-20">Invitaciones pendientes</h2>

        <b-table
        v-if="invitations"
        :data="invitationsCount > 0 ? invitations : []"
        :loading="invitationsLoading">

            <template slot-scope="props">
                <b-table-column width=40>
                    <a 
                    class="has-text-danger"
                    @click="deleteExistingInvite(props.row.id)">
                        <b-icon icon="trash" size="is-small">
                        </b-icon>
                    </a>
                </b-table-column>
                <b-table-column field="fullName" label="Nombre" >
                    {{props.row.userFirstName}} {{props.row.userLastName}}
                </b-table-column>

                <b-table-column field="userEmail" label="Email" >
                    {{props.row.userEmail}}
                </b-table-column>

                <b-table-column field="userPhoneNumber" label="Estado" >
                    {{props.row.status}}
                </b-table-column>

            </template>

        </b-table>
        <div class="p-top-30 p-b-30" v-if="invitations">
            <b-pagination
                :total="invitationsCount"
                :per-page="perPage"
                :current.sync="invitationsPage"
                :range-before="2"
                :rounded="true"
                :range-after="2"
                order="is-centered"
                @change="invitePageChange"
                icon-prev="chevron-left"
                icon-next="chevron-right"
            >
            </b-pagination>
        </div>

        <b-modal :active.sync="invitesModal" scroll="keep">
            <div class="modal-card" style="width: auto">
                
                <div class="modal-card-body">
                    <div v-for="(x, i) in newInvites"
                    :key="i"
                    class="columns is-multiline">
                        <div class="column is-full">
                            <a class="has-text-danger"
                            @click="deleteNewMember(i)">
                                <b-icon icon="trash" size="is-small"></b-icon>
                                Delete
                            </a>
                        </div>
                        <div class="column is-one-third">
                            <b-field label="Email">
                                <b-input
                                v-model="x.userEmail">
                                </b-input>
                            </b-field>
                        </div>
                        <div class="column is-one-third">
                            <b-field label="First name">
                                <b-input
                                v-model="x.userFirstName">
                                </b-input>
                            </b-field>
                        </div>
                        <div class="column is-one-third">
                            <b-field label="Last Name">
                                <b-input
                                v-model="x.userLastName">
                                </b-input>
                            </b-field>
                        </div>
                    </div>
                    <b-button
                    type="is-light"
                    rounded
                    @click="addNewMemberInvite"
                    >
                        <b-icon icon="plus" size="is-small"></b-icon>
                        Add new member line
                    </b-button>
                    <div class="columns p-t-30">
                        <div class="column is-full has-text-centered">
                            <b-button
                                type="is-primary"
                                rounded
                                @click="inviteMembers">
                                    <b-icon icon="plus" size="is-small"></b-icon>
                                    Invite new members
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>


    </div>
</template>

<script>
import {getHandler, postHandler, deleteHandler} from "./../../../../services/http.js"

export default {
    props:{
        memberList:{
            type:String,
            default:''
        },
        invitationList:{
            type:String,
            default:''
        },
        invitationDetail:{
            type:String,
            default:''
        }
    },
    data(){
        return{
            perPage:24,
            members:[],
            membersPage:1,
            membersCount:0,
            membersLoading:false,
            invitations:[],
            invitationsPage:1,
            invitationsCount:0,
            invitationsloading:false,

            newInvites:[
                {
                    userEmail:'',
                    userFirstName:'',
                    userLastName:''
                },
            ],
            invitesModal:false
        }
    },
    methods:{
        async fetchMembers(){
            let url = this.memberList + `?page=${this.membersPage}`
            let response = await getHandler(url, {error:false, success:false})
            this.members = response.results
            this.membersCount = response.count
        },
        async fetchInvitations(){
            let url = this.invitationList + `?page=${this.invitationsPage}`
            let response = await getHandler(url, {error:false, success:false})
            this.invitations = response.results
            this.invitationsCount = response.count
        },
        async inviteMembers(){
            let msg = {
                resource:'notify'
            }
            let response = await postHandler(this.memberList, this.newInvites, {error:msg, success:msg})
            this.newInvites = [
            {
                userEmail:'',
                userFirstName:'',
                userLastName:''
            },
            ]
            this.fetchInvitations()
        },
        async deleteExistingInvite(id){
            let msg = {
                resource: "notify"
            }
            let url = this.invitationDetail.replace('0000', id)
            let response = await deleteHandler(url, {erorr:msg, success:msg})
            this.fetchInvitations()
        },

        deleteNewMember(index){
            this.newInvites.splice(index, 1)
        },
        addNewMemberInvite(){
            this.newInvites.push(
                {
                    userEmail:'',
                    userFirstName:'',
                    userLastName:''
                }
            )
        },
        memberPageChange(num){
            this.membersPage = num
            this.fetchMembers()
        },
        invitePageChange(num){
            this.invitationsPage = num
            this.fetchMembers()
        }
    },
    created(){
        this.fetchMembers()
        this.fetchInvitations()
    }

}
</script>
